export default __webpack_public_path__ + "static/media/bear-purple.ba441f97.svg";